import type { ShopApiDto, CommonDto } from '@do/data-transfer-objects';

import { historyIcons, historyLabels } from '../configs';
import type { HistoryType, HashWithLink } from '../types';

//type guards
const hasTransferredTo = (item: any): item is { transferred_to: HashWithLink } => 'transferred_to' in item;
const hasPriceFormatted = (item: any): item is { price_formatted: string } => 'price_formatted' in item;
const hasMintedTo = (item: any): item is { minted_to: HashWithLink } => 'minted_to' in item;
const hasCurrency = (item: any): item is { currency: string } => 'currency' in item;
const hasBuyer = (item: any): item is { buyer: HashWithLink } => 'buyer' in item;

export const mapHistoryData = (historyData: ShopApiDto.TokenHistoryResponse['data']): HistoryType[] => {
  return historyData.map((item) => {
    return {
      date: item.block_timestamp,
      label: historyLabels[item.kind],
      type: item.kind,
      icon: historyIcons[item.kind],
      fromValue: item.from,
      tx: item.tx_hash,
      toValue: hasTransferredTo(item) ? item.transferred_to : undefined,
      mintedToValue: hasMintedTo(item) ? item.minted_to : undefined,
      price: hasPriceFormatted(item) ? item.price_formatted : undefined,
      currency: hasCurrency(item) ? item.currency : undefined,
      buyer: hasBuyer(item) ? item.buyer : undefined,
    };
  });
};

export const getCurrencyName = (currencies: CommonDto.CurrenciesList, id: string): string => {
  return (currencies && currencies.find((currency) => currency.id === id)?.name) || '';
};
